(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["moviq-load-more"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('moviq-load-more')) {
    class MoviqLoadMore extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      onClick = async (event) => {
        const link = event.target.closest('[data-next]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey) return;
        event.preventDefault();
        if (this.busy) return;
        this.busy = true;
        link.classList.add('is-loading');
        link.setAttribute('aria-busy', 'true');

        try {
          const url = new URL(link.href, window.location.href);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const res = await fetch(url.toString());
          if (!res.ok) throw new Error(res.status);
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');

          const scope = this.closest('#ResultsList') || document;
          const grid = scope.querySelector('.product-grid');
          const items = [...doc.querySelectorAll('.product-grid > .product-grid__item')];
          if (!grid || !items.length) throw new Error('geen producten');

          items.forEach((item) => grid.append(item));
          items[0].querySelector('a[href]')?.focus({ preventScroll: true });

          const fresh = doc.querySelector('moviq-load-more');
          if (fresh) this.replaceWith(fresh);
          else this.remove();
        } catch (error) {
          window.location.href = link.href;
        } finally {
          this.busy = false;
          link.classList.remove('is-loading');
          link.removeAttribute('aria-busy');
        }
      };
    }

    customElements.define('moviq-load-more', MoviqLoadMore);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["moviq-variant-styles"] && !Shopify.designMode) return;
  try {
    /* MOVIQ: uitverkochte maten zijn niet te kiezen (ook niet met het toetsenbord).
     Geldt alleen voor maatblokjes, niet voor kleurstalen. */
  (() => {
    if (window.__moviqBlockSoldOut) return;
    window.__moviqBlockSoldOut = true;

    const isSoldOutSize = (input) =>
      input &&
      input.matches('variant-picker input[type="radio"][data-option-available="false"]') &&
      !input.closest('.variant-option__button-label--has-swatch');

    document.addEventListener(
      'click',
      (event) => {
        const label = event.target.closest('variant-picker .variant-option__button-label');
        if (!label) return;
        if (isSoldOutSize(label.querySelector('input'))) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );

    // Pijltjestoetsen springen over uitverkochte maten heen
    document.addEventListener(
      'keydown',
      (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
        const current = event.target;
        if (!current.matches?.('variant-picker input[type="radio"]')) return;
        if (current.closest('.variant-option__button-label--has-swatch')) return;
        const group = [...current.closest('fieldset').querySelectorAll('input[type="radio"]')];
        const step = event.key === 'ArrowLeft' || event.key === 'ArrowUp' ? -1 : 1;
        let i = group.indexOf(current);
        for (let n = 0; n < group.length; n++) {
          i = (i + step + group.length) % group.length;
          if (!isSoldOutSize(group[i])) break;
        }
        if (isSoldOutSize(group[i]) || group[i] === current) return;
        event.preventDefault();
        group[i].focus();
        group[i].click();
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
